module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Fucking Pterodactyl")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#characterjob-with-description"
    }
  }, [_c('strong', [_vm._v("Character/Job with Description")])]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#zebra-ice-through-axiton-andromeda"
    }
  }, [_vm._v("Zebra-Ice through Axiton, Andromeda")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch005#zebra-ice",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zebra-Ice")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch005#deep-blue-and-light-aqua-zebra-icebergs",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deep Blue and Light Aqua Zebra-Icebergs")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#an-afternoons-invitation-to-downing-street",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Afternoon’s Invitation to "), _c('strong', [_vm._v("Downing")]), _vm._v(" Street")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#madam-ambassador-anastazia-roxeski-at-downing-street",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Madam Ambassador Anastazia Roxeski at Downing Street")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#downing-street-euro--ukrainian-joint-tv-address",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Downing Street & Euro- Ukrainian Joint TV Address")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#madam-ambassador-anastazia-roxeski-at-downing-street-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Madam Ambassador Anastazia Roxeski at Downing Street")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#her-majestys-euro--intergalactic-space-castle",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Her Majesty’s Euro- Intergalactic Space Castle")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#by-royal-appointment-madam-ambassador-anastazia-roxeski-is-knighted",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("By Royal Appointment, Madam Ambassador Anastazia Roxeski Is Knighted")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#saxon",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saxon")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#madam-prime-ministers-questions",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Madam Prime Minister’s Questions")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#aquion-was-besieged-with-orion-fighter-ships-in-an-intense-week-of-laser-gunfire-andromeda",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aquion was besieged with Orion fighter-ships in an intense week of laser gunfire, Andromeda")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#orion-wages-an-intergalactic-taxes-war-against-aquion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Orion wages an Intergalactic Taxes War against Aquion!")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#saxon-house-chamber",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saxon House Chamber")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#press-intrusions-opposition-strikes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Press Intrusions, Opposition & Strikes")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#aquion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aquion")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#toothblade-cortex-communications",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Toothblade & Cortex Communications")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#byxin",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Byxin")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#andromeda",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Andromeda")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#aquion-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aquion")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#toothblade-victory",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Toothblade Victory")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#xoxox-spiral-galaxy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Xoxox Spiral Galaxy")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#quozal-black-hole",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quozal Black Hole")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#axiton",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Axiton")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#alexi-novinskys-assassins-failed-plot-with-his-trip-to-axiton",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alexi Novinsky’s Assassins failed plot with his Trip to Axiton!")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#eos-beckons-saxas-aeronautics-and-space-administration",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eos Beckons, Saxas Aeronautics and Space Administration")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#axiton-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Axiton")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#saxas",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saxas")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#democratic-assassins-within-our-gaia-house",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Democratic Assassins Within Our Gaia House!")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#governments-with-android-orders",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Governments with Android Orders")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#european-brazilian-androids-production",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("European & Brazilian Androids Production")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#destinations",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Destinations")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#rio-de-janeiro-london",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rio de Janeiro & London")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#miami-florida",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Miami, Florida")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#du-plessiss-fashion-house",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("du Plessis’s Fashion House")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#miami-supreme-court",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Miami Supreme Court")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#spikes-rejected-divorce",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spikes Rejected Divorce")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#saxon-house-chambers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saxon House Chambers")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#du-plessis-gate",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("du Plessis-Gate")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#destination-axiton-andromeda",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Destination Axiton Andromeda")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#the-commons-londonsaxas",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Commons, London–Saxas")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#axiton-supreme-court-andromeda-galaxy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Axiton Supreme Court, Andromeda Galaxy")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#axiton-versus-three-british-euro-democrats",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Axiton versus Three British-Euro Democrats")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#androids-deliveries",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Androids Deliveries")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#saxas-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saxas")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#byxin-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Byxin")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#andromeda-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Andromeda")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#saxon-androids-activated-and-working",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saxon Androids Activated and Working!")])]), _c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#so-aquion-and-lepi-are-besieged-with-biological-workers-as-both-export-exotic-jewellery-andromeda",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("So – Aquion and Lepi Are Besieged with Biological Workers as Both Export Exotic Jewellery, Andromeda")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#aquion-and-lepi-asteroid-belt-mining-colonies",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aquion and Lepi Asteroid-belt Mining Colonies!")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#axiton-andromeda",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Axiton, Andromeda")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#saxas-aeronautics-and-space-administration",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saxas Aeronautics and Space Administration")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0